import * as React from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import PeriodCountItem from 'src/models/personnel/PeriodCountItem';

interface IPeriodCountDialogProps {
    dialogName: string;
    hideDialog: () => void;
    items: Array<PeriodCountItem>;
}

// Mirrors te_checklist_billable_report - a read-only report (Office/Classification, Checklist
// Total/Grand Total, Entered Total/Grand Total), single Back button. Row coloring mirrors
// POST-QUERY's own rules: an office subtotal row (billingClass 'Office Total') is cyan, the one
// Grand Total row is green, and the Billable/Non-Billable breakdown rows (orderNo 4) are yellow -
// applied to the whole row here rather than 3 of 4 individual cells, a small simplification.
const PeriodCountDialog = (props: IPeriodCountDialogProps) => {
    const rowColor = (item: PeriodCountItem): string | undefined => {
        if (item.billingClass === 'Grand Total') {
            return '#d4f7d4';
        }
        if (item.billingClass === 'Office Total') {
            return '#d4f0f7';
        }
        if (item.orderNo === 4) {
            return '#fdf6c9';
        }
        return undefined;
    };

    return (
        <Dialog title="Period Count" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '45%' }}>
            <div style={{ overflowY: 'auto', maxHeight: '24rem' }}>
                <table style={{ width: '100%' }}>
                    <thead>
                        <tr>
                            <th rowSpan={2}>Office</th>
                            <th rowSpan={2}>Classification</th>
                            <th colSpan={2} style={{ textAlign: 'center' }}>Checklist</th>
                            <th colSpan={2} style={{ textAlign: 'center' }}>Entered</th>
                        </tr>
                        <tr>
                            <th>Total</th>
                            <th>Grand Total</th>
                            <th>Total</th>
                            <th>Grand Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.items.map((item, index) => (
                            <tr key={index} style={{ textAlign: 'center', backgroundColor: rowColor(item) }}>
                                <td>{item.office}</td>
                                <td>{item.billingClass}</td>
                                <td>{item.cnt}</td>
                                <td>{item.total}</td>
                                <td>{item.entered}</td>
                                <td>{item.enteredTotal}</td>
                            </tr>
                        ))}
                        {props.items.length === 0 && (
                            <tr>
                                <td colSpan={6} className="bold-centered">No Records Found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <div className="form-row" style={{ marginTop: '1rem', justifyContent: 'center' }}>
                <Button className="blue-hover-button" style={{ width: 'auto' }} text="Back" onClick={() => props.hideDialog()} />
            </div>
        </Dialog>
    );
};

export default PeriodCountDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/employeePayroll/PeriodCountDialog.tsx